import { render, staticRenderFns } from "./InsertCustomForm.vue?vue&type=template&id=c1865972"
import script from "./InsertCustomForm.vue?vue&type=script&lang=js"
export * from "./InsertCustomForm.vue?vue&type=script&lang=js"
import style0 from "./InsertCustomForm.vue?vue&type=style&index=0&id=c1865972&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports